import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../../_components/configuration-header-wrapper.component'
import { AddContentForm } from '../../_components/content-forms.component'
import { EContentType } from '../../_components/content.type'

export default function AddContentContentPage() {
  const { t } = useTranslation()

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.contents.add-content')}
      className="c-overflow-visible"
    >
      <p className="c-text-grey-600 c-font-nexa c-font-light c-text-sm">
        {t('pages.configuration.contents.start-to-select-language-content')}
      </p>
      <AddContentForm contentType={EContentType.CONTENT} />
    </ConfigurationHeaderWrapper>
  )
}
